import { Delete, Get, Post } from "axios/AxiosFunctions";
import Box from "components/Core/Box";
import { Button } from "components/Core/Button";
import SearchInput from "components/Core/SearchInput";
import SideBarSkeleton from "components/Core/SideBarSkeleton";
import TableStructure from "components/Core/TableStructure";
import TableActionHandler from "components/TableActionHandler";
import { BaseURL } from "config/apiUrl";
import { recordsLimit } from "constant/constants";
import { cycleHeaders } from "constant/data";
import useDebounce from "customHooks/useDebounce";
import { apiHeader, formatDate, RenderToast } from "helper/HelperFunction";
import AddEditCycleModal from "modals/AddEditCycleModal";
import AreYouSureModal from "modals/AreYouSureModal";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classes from "./Cycle.module.css";
const loadingStates = {
  GET_CYCLES: "GET_CYCLES",
  SUBMIT: "SUBMIT",
};
const modalStates = {
  SUBMIT: "SUBMIT",
  CREATE_CYCLE: "CREATE_CYCLE",
  DELETE_CYCLE: "DELETE_CYCLE",
};
const Cycle = () => {
  const { access_token } = useSelector((state) => state.authReducer);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [cycles, setCycles] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [modal, setModal] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  // get cycles
  const getCycles = async (pgNo = page) => {
    const url = BaseURL(
      `cycles/find/all?page=${pgNo}&limit=${recordsLimit}&search=${debouncedSearch}`
    );
    setLoading(loadingStates.GET_CYCLES);
    const response = await Get(url, access_token);
    if (response) {
      setCycles(response?.data?.data);
      setTotalCount(response?.data?.total);
    }
    setLoading(false);
  };
  //  add  cycle
  const handleAddCycle = async (params) => {
    const url = BaseURL(`cycles`);
    setLoading(loadingStates.SUBMIT);
    const response = await Post(url, params, apiHeader(access_token));
    if (response) {
      setModal(null);
      setCycles((prev) => [response?.data, ...prev]);
      RenderToast("success", "Cycle created successfully");
    }
    setLoading(false);
  };
  //   delete cycle
  const handleDelete = async () => {
    const url = BaseURL(`cycles/delete/${selectedItem?._id}`);
    setLoading(loadingStates.SUBMIT);
    const response = await Delete(url, apiHeader(access_token));
    if (response) {
      setCycles(cycles.filter((item) => item?._id !== selectedItem?._id));
      RenderToast("success", "Cycle deleted successfully");
      setModal(null);
      setSelectedItem(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCycles();
  }, [debouncedSearch]);
  return (
    <>
      <SideBarSkeleton headerHeading={"Cycle"}>
        <Box variant="bare">
          <div className={classes.header_container}>
            <div className={classes.search}>
              <SearchInput value={search} setter={setSearch} />
            </div>
            <div className={classes.actions_container}>
              <Button
                label={"New Cycle"}
                variant="primary"
                onClick={() => {
                  setModal(modalStates.CREATE_CYCLE);
                }}
              />
            </div>
          </div>
          <div className={classes.tableWrapper}>
            <TableStructure
              isLoading={loading === loadingStates.GET_CYCLES}
              tableHeaders={cycleHeaders}
              noDataMessage={"No cycles found"}
              customStyle={{ height: "calc(100vh - 232px)" }}
              page={page}
              setPage={(e) => {
                setPage(e);
                getCycles(e);
              }}
              tableMinWidth={1000}
              totalRecord={totalCount}
              tableContent={cycles?.map((item) => ({
                ...item,
                createdAt: formatDate(item?.createdAt),
                actions: (
                  <TableActionHandler
                    onDelete={() => {
                      setSelectedItem(item);
                      setModal(modalStates.DELETE_CYCLE);
                    }}
                  />
                ),
              }))}
            />
          </div>
        </Box>
      </SideBarSkeleton>
      {[modalStates.CREATE_CYCLE].includes(modal) && (
        <AddEditCycleModal
          show={[modalStates.CREATE_CYCLE].includes(modal)}
          setShow={() => {
            setModal(null);
            setSelectedItem(null);
          }}
          handleClick={handleAddCycle}
          modalLoading={loading === loadingStates.SUBMIT}
        />
      )}

      {modal === modalStates.DELETE_CYCLE && (
        <AreYouSureModal
          show={modal === modalStates.DELETE_CYCLE}
          setShow={() => {
            setModal(null);
            setSelectedItem(null);
          }}
          isApiCall={loading === loadingStates.SUBMIT}
          onClick={handleDelete}
          title={"Are you sure?"}
          subTitle={`You are about to delete cycle ${selectedItem?.name}.`}
        />
      )}
    </>
  );
};

export default Cycle;
